import { Alert, Modal, Select, Checkbox, Icon } from 'components'
import {
  Container,
  Content,
  ContentDate,
  DescriptionWrapper,
  InputDate,
  Label
} from './styles'
import { useState, useEffect, Dispatch, SetStateAction } from 'react'
import { setDuplicateOrder } from 'store/SalesOrderContext/salesOrderSlice'
import { useSelector } from 'store/store'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { getUser } from 'commons/utils/user'
import { CustomBoolean, TypesValidations } from 'constants/enums'

export interface PropsModal {
  open: boolean
  setOpen: Dispatch<SetStateAction<boolean>>
  handleDuplicated: (() => void) | undefined
}

const ModalDuplicate = ({ open, setOpen, handleDuplicated }: PropsModal) => {
  const [dataDelivery, setDataDelivery] = useState<string>('')
  const [typeMaterial, setTypeMaterial] = useState<CustomBoolean>(TypesValidations.NO)
  const [keepMaterial, setKeepMaterial] = useState<boolean>(true)
  const [showWarning, setShowWarning] = useState<boolean>(false)
  const { orderNumber } = useParams()
  const { duplicateOrder, draftBody } = useSelector((state) => state.salesOrder)
  const dispatch = useDispatch()
  const materialOptions = [
    {
      value: TypesValidations.NO,
      title: 'Padrão'
    },
    {
      value: TypesValidations.YES,
      title: 'MTO'
    }
  ]

  const handleTypeChange = (newType: CustomBoolean) => {
    if (
      draftBody.fl_mto_prep === TypesValidations.NO &&
      newType === TypesValidations.YES
    ) {
      setShowWarning(true)
      setKeepMaterial(false)
    } else {
      setShowWarning(false)
      setKeepMaterial(duplicateOrder.Clientes[0].fl_dupl_matr === TypesValidations.YES)
    }

    setTypeMaterial(newType)
    dispatch(
      setDuplicateOrder({
        ...duplicateOrder,
        Clientes: [{ ...duplicateOrder?.Clientes[0], fl_mto_prep: newType }]
      })
    )
  }

  const handleClose = () => {
    setOpen(false)
    handleTypeChange(draftBody.fl_mto_prep)
  }

  useEffect(() => {
    if (draftBody?.fl_mto_prep) {
      setTypeMaterial(draftBody.fl_mto_prep)
      if (orderNumber) {
        dispatch(
          setDuplicateOrder({
            ...duplicateOrder,
            nr_pedi_rasc_orig: String(orderNumber),
            Clientes: [
              {
                fl_mto_prep: draftBody.fl_mto_prep,
                fl_dupl_matr: TypesValidations.YES,
                cd_clie: draftBody.cd_clie,
                fl_dupl_text: TypesValidations.YES,
                nr_pedi_clie: ''
              }
            ],
            cd_usua_alte: getUser()
          })
        )
      } else {
        dispatch(
          setDuplicateOrder({
            ...duplicateOrder,
            Clientes: [
              {
                fl_mto_prep: draftBody.fl_mto_prep,
                fl_dupl_matr: TypesValidations.YES,
                cd_clie: draftBody.cd_clie,
                fl_dupl_text: TypesValidations.YES,
                nr_pedi_clie: ''
              }
            ],
            cd_usua_alte: getUser()
          })
        )
      }
    }
  }, [orderNumber, draftBody?.fl_mto_prep])

  useEffect(() => {
    if (Object.keys(!duplicateOrder)?.length) {
      const clientes = {
        cd_clie: draftBody.cd_clie,
        fl_mto_prep: draftBody.fl_mto_prep,
        fl_dupl_matr: TypesValidations.YES,
        nr_pedi_clie: draftBody.nr_pedi_clie,
        fl_dupl_text: TypesValidations.YES
      }
      const body = {
        nr_pedi_rasc_orig: orderNumber || '',
        Clientes: [clientes],
        cd_usua_alte: getUser()
      }
      dispatch(setDuplicateOrder(body))
    }
  }, [])
  useEffect(() => {
    if (duplicateOrder?.Clientes?.length) {
      setTypeMaterial(duplicateOrder?.Clientes[0]?.fl_mto_prep as CustomBoolean)
    }
  }, [duplicateOrder?.Clientes])

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      title="Duplicar Pedido"
      closeAction={handleClose}
      showReturn
      returnText="Cancelar"
      returnAction={handleClose}
      buttonIcon={<Icon icon="duplicate" size="15" />}
      buttonText="Duplicar"
      buttonAction={handleDuplicated}
    >
      <Container>
        <Content>
          <DescriptionWrapper>
            Você está duplicando o{' '}
            <strong>Pedido #{duplicateOrder?.nr_pedi_rasc_orig}</strong>. Para prosseguir,
            preencha os campos abaixo.
          </DescriptionWrapper>
        </Content>
        {
          //TODO: Verificar se esse campo será necessário para Duplicacao de pedidos e não de rascunhos
          false && (
            <Content>
              <ContentDate>
                <Label>Data de entrega</Label>
                <InputDate
                  type="date"
                  placeholder="Data Inicial"
                  value={dataDelivery}
                  onChange={(e) => {
                    setDataDelivery(e.target.value)
                    dispatch(
                      setDuplicateOrder({
                        ...duplicateOrder,
                        data_delivery: e.target.value
                      })
                    )
                  }}
                />
              </ContentDate>
            </Content>
          )
        }
        <Content>
          <Select
            name="select"
            value={typeMaterial}
            defaultValue="N"
            label="Tipo de material"
            focused={false}
            options={materialOptions}
            onChange={(e) => {
              if (e.target.value) {
                handleTypeChange(e.target.value as CustomBoolean)
              }
            }}
          />
        </Content>
        {showWarning && (
          <Content>
            <Alert
              fullWidth
              kind="warning"
              title="Tipo de material alterado"
              message="Ao alterar o tipo de material você poderá perder os materiais inseridos."
            />
          </Content>
        )}
        <Content>
          <Checkbox
            checked={keepMaterial}
            disabled={showWarning}
            onChange={(e) => {
              setKeepMaterial(e.target.checked)
              dispatch(
                setDuplicateOrder({
                  ...duplicateOrder,
                  Clientes: [
                    {
                      ...duplicateOrder?.Clientes[0],
                      fl_dupl_matr: e.target.checked
                        ? TypesValidations.YES
                        : TypesValidations.NO
                    }
                  ]
                })
              )
            }}
            label="Manter Materiais"
          />
        </Content>
        {
          //TODO: Verificar se esse campo será necessário para Duplicacao de pedidos e não de rascunhos
          false && (
            <Content>
              <Checkbox
                checked={false}
                onChange={() => {
                  return
                }}
                label="Manter configuração do pedido"
              />
            </Content>
          )
        }
      </Container>
    </Modal>
  )
}

export default ModalDuplicate
